/**
 * ZoomControls Component
 * Displays zoom control buttons
 */

import styles from './ZoomControls.module.css'

interface ZoomControlsProps {
  zoom: number
  onZoomIn: () => void
  onZoomOut: () => void
  onRotate: () => void
  onFitToScreen: () => void
}

export function ZoomControls({
  zoom,
  onZoomIn,
  onZoomOut,
}: ZoomControlsProps) {
  return (
    <div className={styles.zoomControls}>
      <button onClick={onZoomOut} className={styles.toolButton} title="Zoom Out">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
      <span className={styles.zoomLevel}>{Math.round(zoom * 100)}%</span>
      <button onClick={onZoomIn} className={styles.toolButton} title="Zoom In">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <line x1="12" y1="5" x2="12" y2="19" />
          <line x1="5" y1="12" x2="19" y2="12" />
        </svg>
      </button>
      {/* Rotate and Fit to Screen buttons hidden */}
    </div>
  )
}
